import React, { useState, useEffect, useRef } from 'react';
import './ItemModal.scss';
import arrow from "../../../assets/arrow-black.svg"
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { getCurrencyFormat } from '../../../../../../utilities/helper';
import ediitIc from "../../../assets/basil_edit-outline.svg"

const ItemDropdown = ({ options, placeholder = "Select an option", onSelect, selectedItem, modifier, renderModifierGroups, onClick }) => {
    const [selected, setSelected] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleSelect = (option) => {
        onSelect(option);
        setIsOpen(false);
    };
    const handleClick = () => {
        onClick(selectedItem);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const {
        currency,

        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const currencyFormat = getCurrencyFormat(currency);
    const getOptionPriceForCart = (overrides, Id, quantity) => {
        const option = _.find(overrides, { ContextValue: Id });
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.DeliveryPrice || 0, quantity),
            TakeAway: createPriceObj(price?.PickupPrice || 0, quantity),
            DineIn: createPriceObj(price?.TablePrice || 0, quantity),
            CurrencyCode: currency
        });

        const basePrice = getPriceData(option?.Price || {}, 1);
        const totalPrice = getPriceData(option?.Price || {}, quantity);

        return {
            BaseUnitPrice: basePrice,
            BaseTotalPrice: quantity > 1 ? totalPrice : basePrice
        };
    };
    const getThePriceItem = (overrides, Id, quantity) => {
        let price = getOptionPriceForCart(overrides, Id, quantity).BaseTotalPrice
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = price.Delivery.FormattedText;
                break;
            case "table":
                priceValue = price.DineIn.FormattedText;
                break;
            case "collection":
                priceValue = price.TakeAway.FormattedText;
                break;
            default:
                priceValue = price.Delivery.FormattedText;
                break;
        }

        return priceValue;
    };
    const getPriceSelectedOption = (selectedItemPrice) => {
        let price = selectedItemPrice.BaseTotalPrice
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = price.Delivery.FormattedText;
                break;
            case "table":
                priceValue = price.DineIn.FormattedText;
                break;
            case "collection":
                priceValue = price.TakeAway.FormattedText;
                break;
            default:
                priceValue = price.Delivery.FormattedText;
                break;
        }
        return priceValue;
    }
    const getOptionPrice = (priceInfo, Id, quantity) => {
        let option = null
        if (priceInfo?.Overrides) {
            let overrides = priceInfo?.Overrides
            option = _.find(overrides, { ContextValue: Id })
            if (option) {
                return getThePriceItem(overrides, Id, quantity)
            } else {
                return "£0.00"
            }
        } else {
            return getPriceSelectedOption(priceInfo)
        }


    }
    return (
        <div className="ItemDropdown" ref={dropdownRef}>
            <div
                className="ItemDropdown-toggle"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div>{selectedItem?.Title?.replace(/\.+$/, '') || placeholder}</div>
                <div className={`arrow-drp ${isOpen ? 'open' : ''}`}><img alt='' src={arrow} /></div>
            </div>

            {isOpen && (
                <ul className="ItemDropdown-menu">
                    {options.map((option) => (
                        <li
                            key={option.MenuItemID}
                            className="ItemDropdown-item"
                            onClick={() => handleSelect(option)}
                        >
                            {option?.Title?.en?.replace(/\.+$/, '') || option?.Title?.replace(/\.+$/, '')}
                            <span> ({getOptionPrice(option.PriceInfo, modifier.ModifierGroupID, 1)})</span>

                        </li>
                    ))}
                </ul>
            )
            }
            <div className="option-modifier">
                {selectedItem && selectedItem?.SelectedModifierGroups?.length > 0 &&
                    <div className="modifiers-container">
                        {selectedItem && selectedItem?.SelectedModifierGroups && selectedItem?.SelectedModifierGroups?.length > 0 && <div className="selected-mod-container">
                            {renderModifierGroups(selectedItem)}
                        </div>}
                        <div className="edit-container"
                            onClick={() => {
                                console.log(selectedItem, "selectedItem sd")

                                onClick(selectedItem);
                            }}>
                            <img alt="" src={ediitIc} />
                            <div className="edit-text">

                                Edit selections</div>

                        </div>
                    </div>
                }

            </div>
        </div >
    );
};

export default ItemDropdown;
